/**
 * 盤面のすぐ下に出す「進化の列」（12段を小さく1列に）。
 *
 * スイカゲームの「進化の輪」にあたる。スマホでは側面パネルの図鑑が画面の外に出てしまい、
 * 何と何を合わせると何になるのかが遊びながら見えなかった。
 *
 * - 出会った料理は絵、まだの料理は「？」
 * - このプレイで届いた段は明るく、いちばん上の段に印
 * - タップすると料理の説明カード（main.ts から渡す）
 */

import type { GameContext } from '../game/GameContext';
import type { StageItemDefinition } from '../game/config/types';

export class EvolutionStrip {
  private readonly root: HTMLElement;
  private readonly cells = new Map<string, HTMLButtonElement>();
  private reached = 0;
  onOpen?: (item: StageItemDefinition) => void;

  constructor(
    private readonly context: GameContext,
    anchor: Element | null,
  ) {
    this.root = document.createElement('div');
    this.root.className = 'evo-strip';
    this.root.setAttribute('role', 'group');
    this.root.setAttribute('aria-label', '合体していく順番');
    for (const item of context.items) {
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'evo-strip__cell';
      const img = document.createElement('img');
      img.alt = '';
      img.width = 28;
      img.height = 28;
      const q = document.createElement('span');
      q.className = 'evo-strip__q';
      q.textContent = '？';
      cell.append(img, q);
      cell.addEventListener('click', () => this.onOpen?.(item));
      this.cells.set(item.id, cell);
      this.root.append(cell);
    }
    anchor?.after(this.root);

    const bus = context.bus;
    bus.on('queue:change', () => this.render());
    bus.on('dex:unlock', () => this.render());
    bus.on('run:maxLevel', ({ level }) => {
      this.reached = level;
      this.render();
    });
    this.render();
  }

  private render(): void {
    const { storage, icons } = this.context;
    for (const item of this.context.items) {
      const cell = this.cells.get(item.id)!;
      const revealed = storage.isRevealed(item.id);
      const img = cell.querySelector('img')!;
      if (revealed) {
        if (!img.getAttribute('src')) img.src = icons.iconUrl(item, 64);
      } else {
        img.removeAttribute('src');
      }
      cell.dataset.revealed = String(revealed);
      cell.dataset.reached = String(item.level <= this.reached);
      cell.dataset.top = String(item.level === this.reached);
      cell.setAttribute(
        'aria-label',
        `Lv.${item.level} ${revealed ? item.name : 'まだ出会っていない料理'}${
          item.level <= this.reached ? '（このプレイで到達）' : ''
        }`,
      );
    }
  }
}
